const accordionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.5C0 9.67157 0.573294 9 1.28049 9H14.5976C15.3048 9 15.878 9.67157 15.878 10.5C15.878 11.3284 15.3048 12 14.5976 12H1.28049C0.573294 12 0 11.3284 0 10.5Z"
      fill="#6B00DF"
    />
    <path
      d="M16.9024 10.5C16.9024 9.67157 17.4757 9 18.1829 9H19.7195C20.4267 9 21 9.67157 21 10.5C21 11.3284 20.4267 12 19.7195 12H18.1829C17.4757 12 16.9024 11.3284 16.9024 10.5Z"
      fill="#6B00DF"
    />
  </svg>
);

export { accordionIcon };
